import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=5cebb6b8&scoped=true&"
import script from "./tableList.vue?vue&type=script&lang=js&"
export * from "./tableList.vue?vue&type=script&lang=js&"
import style0 from "./tableList.vue?vue&type=style&index=0&id=5cebb6b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cebb6b8",
  null
  
)

export default component.exports